import { Group, Stack, Text } from "@mantine/core"
import { Card, Missing } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { CountryCell } from "~/components/cells/CountryCell.tsx"
import { SUPPLIER_CARD_HEIGHT } from "~/pages/Brand/Products/Details/constants.ts"
import { useGetOperations } from "~/utils/operations"

const SupplierCardDetails = ({
  companyName,
  address,
}: {
  companyName: string | undefined
  address: string | undefined
}) => {
  const { t } = useTranslation("products")

  return (
    <>
      <Group align="flex-start" justify="space-between" wrap="nowrap">
        <Text size="sm">{t("traceability.supplierCard.company")}:</Text>
        <Text size="sm" fw={700} style={{ textAlign: "right" }}>
          {companyName ?? <Missing />}
        </Text>
      </Group>
      <Group align="flex-start" justify="space-between" wrap="nowrap">
        <Text size="sm">{t("traceability.supplierCard.address")}:</Text>
        <Text size="sm" style={{ textAlign: "right" }} fw={700}>
          {address || <Missing />}
        </Text>
      </Group>
    </>
  )
}

type SupplierCardProps = {
  activityName: string
  itemReference?: string
  operation?: LibraryResponses.EnrichedOperation
}

export const SupplierCard = ({
  activityName,
  itemReference,
  operation,
}: SupplierCardProps) => {
  const { t } = useTranslation("products")

  const operationInfo = useGetOperations()[activityName]

  return (
    <Card w={340} h={SUPPLIER_CARD_HEIGHT}>
      <Stack gap="xs">
        <Group justify="space-between" mb="xs" wrap="nowrap" align="flex-end">
          <Group gap="xs" wrap="nowrap">
            {operationInfo.icon && <operationInfo.icon />}
            <Text style={{ fontWeight: "bold" }} size="sm">
              {operationInfo.name}
            </Text>
          </Group>
          <CountryCell countryIso3166={operation?.country.value} />
        </Group>
        <Group align="flex-start" justify="space-between" wrap="nowrap">
          <Text size="sm">{t("traceability.supplierCard.reference")}:</Text>
          <Text
            size="sm"
            style={{ fontWeight: "bold", textAlign: "right" }}
            truncate
          >
            {itemReference ?? <Missing />}
          </Text>
        </Group>

        <SupplierCardDetails
          companyName={operation?.productionSite.value?.companyName}
          address={operation?.productionSite.value?.address}
        />

        <Text />
      </Stack>
    </Card>
  )
}
